export default __webpack_public_path__ + "static/media/1_Intro.9c822d20.mp4";